import React, { Component, PropTypes } from 'react';

class DefaultDecorator extends Component {
	static propTypes = {
		nextSlide: PropTypes.func.isRequired,
		previousSlide: PropTypes.func.isRequired,
		goToSlide: PropTypes.func.isRequired,
		slideCount: PropTypes.number.isRequired,
		currentSlide: PropTypes.number.isRequired,
	};

	static defaultProps = {};

	render() {
		let slideCodas = [];
		let slideClasses = this.props.slideClasses;

		for (let i = 0; i < this.props.slideCount; i++) {
			let isVid = false;
			let className = 'slide-coda__item';
			if (this.props.currentSlide === i) {
				className += ' slide-coda__item--active';
			}

			if (typeof slideClasses[i] === 'string') {
				className += slideClasses[i];
			}

			if (slideClasses.length && !!this.props.hasVideo && slideClasses[i].indexOf('is-video') > -1) {
				slideCodas.push(<a key={i} onClick={() => {this.playAndGo(i)}}><span className={className}></span></a>);
			} else {
				slideCodas.push(<a key={i} onClick={() => { this.props.goToSlide(i, true); }}><span className={className}></span></a>);
			}
		}

		return (
			<div className='slide-coda'>
				{slideCodas}
			</div>
		);
	}

	playAndGo(i) {
		this.props.onVideoPlay();
		//this.props.goToSlide(i, true);
	}
}

let defaultDecoratorPkg = {
	component: DefaultDecorator,
	style: {},
};

export default defaultDecoratorPkg;



/** WEBPACK FOOTER **
 ** ./frontend/components/carousel/defaultDecorator.js
 **/